import { ICategoria } from "shared/interfaces/ICategoria";
import { api } from "../api";

/* ================================
   BUSCAR CATEGORIAS
================================ */

export async function buscarCategorias(): Promise<ICategoria[]> {
  try {
    const response = await api.get("/categories");

    const categorias = Array.isArray(response.data)
      ? response.data
      : response.data?.categories ?? [];
    
    return categorias.map((categoria: any) => ({
      id: categoria.id,
      nome: categoria.name,
      slug: categoria.slug,
      parentId: categoria.parentId ?? null,
      icon: "",
    }));
  } catch (error) {
    console.error("❌ Erro ao buscar categorias:", error);

    return [];
  }
}